<div class="nav-search-wrapper">
    @if (sidebarService.isBelowMobileWidth()) {
        <div class="divider"></div>
    }
    <ul class="ul-list">
        <div class="ul-inner-wrapper">
            <li
                [className]="isCurrentId(resultMap()['all'] + '-' + 0) ? 'search-result-wrapper hover-effect' : 'search-result-wrapper'"
                [id]="resultMap()['all'] + '-' + 0"
                (click)="viewFullSearch(resultMap()['all'] + '-' + 0)"
                (mouseenter)="changeHoverStyle($event)"
                (mouseleave)="changeHoverStyle($event)"
                data-category="all"
                data-testid="search-preview-show-all-results-button"
            >
                <div class="label-wrapper">
                    <div class="label-div" tabindex="0">
                        {{ "search.common.show_all_results" | translate }} <strong>{{ this.searchService.searchInputValue() }}</strong>
                    </div>
                </div>
            </li>
        </div>
    </ul>

    <!-- search suggestions -->
    @if (filteredSuggestions().length > 0) {
        <div class="divider"></div>
        <div class="category-title">
            <h6>{{ "search.suggested_filters" | translate }}</h6>
        </div>
        <ul class="ul-list">
            <div class="ul-inner-wrapper">
                @for (suggestion of filteredSuggestions(); track suggestion.id) {
                    <li
                        [className]="isCurrentId(suggestion.id) ? 'preview-suggestion-line search-result-wrapper hover-effect' : 'preview-suggestion-line search-result-wrapper'"
                        (mouseenter)="changeHoverStyle($event)"
                        (mouseleave)="changeHoverStyle($event)"
                        [id]="suggestion.id"
                        (click)="selectSuggestion(suggestion.short_code)"
                        [attr.data-category]="suggestion.id"
                        [attr.data-testid]="'search-preview-suggestion-' + suggestion.id + '-button'"
                    >
                        <div class="preview-suggestion-content">
                            <div>
                                <div>
                                    <div class="short-code">
                                        <span class="short-code-highlight">
                                            {{ suggestion.short_code }}
                                        </span>
                                    </div>
                                    <div class="suggestion-label">{{ "search.suggestions." + suggestion.id | translate }}</div>
                                </div>
                            </div>
                            <div>
                                <div class="suggestion-example">
                                    {{ suggestion.example }}
                                </div>
                            </div>
                        </div>
                    </li>
                }
            </div>
        </ul>
    }

    @if (searchService.fuzzySearchResult()) {
        @for (category of searchFuzzyCategories(); track category) {
            <ul class="ul-list">
                <div class="ul-inner-wrapper">
                    <div class="divider"></div>

                    <div class="category-title">
                        <h6>{{ "misc." + category + "s" | translate }}</h6>
                    </div>
                    @for (item of searchService.fuzzySearchResult()[category]; let i = $index; track item.id) {
                        <li
                            [className]="isCurrentId(fuzzyResultMap()[category] + '-' + i) ? 'search-result-wrapper hover-effect' : 'search-result-wrapper'"
                            (mouseenter)="changeHoverStyle($event)"
                            (mouseleave)="changeHoverStyle($event)"
                            [id]="fuzzyResultMap()[category] + '-' + i"
                            (click)="navigate(item)"
                            [attr.data-category]="category"
                            [tabIndex]="i + 1"
                            [attr.data-testid]="'search-preview-result-' + (item.id ?? (fuzzyResultMap()[category] + '-' + i))"
                        >
                            <div class="icon-label">
                                <div class="icon-label-wrapper">
                                    <img class="icon-img" alt="Icon" [src]="'assets/icons/search-icons/' + category + '-icon' + (isCurrentId(fuzzyResultMap()[category] + '-' + i) ? '-white' : '') + '.svg'" />
                                    @if (item.val[0] !== "-") {
                                        <div class="label-div" [innerHTML]="searchService.highlightText(item.val[0])"></div>
                                    } @else {
                                        <div class="label-div">
                                            <i>{{ "location.terminal" | translate }}</i>
                                        </div>
                                    }
                                </div>
                                @if (category === "transaction" && item.val[1] && item.val[11]) {
                                    <div class="label-div" [innerHTML]="searchService.highlightText(helperService.localizeNumberWithCurrency(item.val[1] / 100, 2, 2, item.val[11]))"></div>
                                } @else if (item.val[1] && category !== "settlement") {
                                    <div class="label-div" [innerHTML]="searchService.highlightText(item.val[1])"></div>
                                }
                            </div>
                        </li>
                    }
                </div>
            </ul>
        }
    }

    @if (searchService.hasFuzzyResult() === "NO_RESULT") {
        <div class="search-no-data">
            <img class="search-icon mb-2" src="assets/icons/search-icon-active.svg" alt="search icon" />
            <h4>{{ "search.common.no_results" | translate }}</h4>
            <div>{{ "search.common.try_again" | translate }}</div>
        </div>
    }
</div>
